import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import axios from 'axios';
import 'slick-carousel/slick/slick.css';
import '../styles/InstagramCarousel.css';

/* ---------- стрелки слайдера ---------- */
const PrevArrow = ({ className, onClick }) => (
  <div className={className} onClick={onClick} />
);
const NextArrow = ({ className, onClick }) => (
  <div className={className} onClick={onClick} />
);

export const InstagramCarousel = () => {
  const [posts, setPosts] = useState([]);
  const sliderRef = useRef(null);

  /* ---------- получаем посты ---------- */
  useEffect(() => {
    (async () => {
      try {
        const token  = process.env.REACT_APP_IG_TOKEN;
        const userId = process.env.REACT_APP_IG_USER_ID;
        const fields =
          'id,media_type,media_url,permalink,media_product_type';
        const limit = 25; // берём с запасом

        const { data } = await axios.get(
          `https://graph.instagram.com/${userId}/media`,
          { params: { fields, access_token: token, limit } }
        );

        const ordered = [];

        for (const item of data.data) {
          // пропускаем Reels
          if (item.media_product_type === 'REELS') continue;

          if (item.media_type === 'IMAGE') {
            ordered.push(item);
            continue;
          }

          if (item.media_type === 'CAROUSEL_ALBUM') {
            try {
              const { data: kids } = await axios.get(
                `https://graph.instagram.com/${item.id}/children`,
                {
                  params: {
                    fields: 'id,media_type,media_url',
                    access_token: token,
                  },
                }
              );

              const firstImg = kids.data.find(
                (c) => c.media_type === 'IMAGE'
              );

              if (firstImg) {
                ordered.push({
                  ...firstImg,
                  // permalink не нужен, оставляем для отладки
                  permalink: item.permalink,
                });
              }
            } catch (err) {
              console.warn('Children fetch failed:', item.id, err);
            }
          }
        }

        setPosts(ordered);
      } catch (err) {
        console.error('Instagram fetch error:', err);
      }
    })();
  }, []);

  /* ---------- плавный горизонтальный скролл (тачпад) ---------- */
  useEffect(() => {
    if (!sliderRef.current) return;
    const node = sliderRef.current.innerSlider.list;
    const handler = (e) => {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        e.deltaX > 0
          ? sliderRef.current.slickNext()
          : sliderRef.current.slickPrev();
      }
    };
    node.addEventListener('wheel', handler, { passive: false });
    return () => node.removeEventListener('wheel', handler);
  }, []);

  /* ---------- открываем профиль theriffmag корректно на iOS/Android ---------- */
  const handleProfileRedirect = (e) => {
    // Если это не мобильный Safari/Chrome — стандартный переход откроет вкладку
    const isMobile =
      /iphone|ipad|ipod|android/i.test(navigator.userAgent);

    if (!isMobile) return;

    e.preventDefault(); // глушим «обычную» навигацию
    const appUrl = 'instagram://user?username=theriffmag';
    const webUrl = 'https://instagram.com/theriffmag';

    // Пытаемся запустить нативное приложение
    window.location.href = appUrl;

    // Через 1 сек — если приложение не подхватило ссылку — открываем веб-профиль
    setTimeout(() => {
      window.open(webUrl, '_blank', 'noopener,noreferrer');
    }, 1000);
  };

  /* ---------- настройки react-slick ---------- */
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '80px',
    arrows: true,
    swipe: true,
    touchMove: true,
    draggable: true,
    swipeToSlide: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0',
        },
      },
    ],
  };

  /* ---------- рендер ---------- */
  return (
    <div className="instagram-carousel">
      <Slider {...settings} ref={sliderRef}>
        {posts.map(({ id, media_url }) => (
          <div key={id} className="slide">
            <a
              href="https://instagram.com/theriffmag"
              onClick={handleProfileRedirect}
              rel="noopener noreferrer"
            >
              <img src={media_url} alt="" />
            </a>
          </div>
        ))}
      </Slider>
    </div>
  );
};
